import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable, tap } from 'rxjs';

import { LoggerService } from '@tablesready/frontend-logger';
import { AuthService } from './auth.service';

export const SKIP_AUTH_HTTP_HEADER_NAME = 'SKIP_AUTH_HTTP_HEADER_NAME';

@Injectable({providedIn: 'root'})
export class AuthHttpInterceptor implements HttpInterceptor {
  constructor(
    private readonly auth: AuthService,
    private readonly logger: LoggerService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(SKIP_AUTH_HTTP_HEADER_NAME)) {
      request.headers.delete(SKIP_AUTH_HTTP_HEADER_NAME);
    } else {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.getToken()}`,
        },
      });
    }

    return next.handle(request).pipe(tap({
      error: err => {
        console.log(request.url);
        if (err.status === 401 && !request.url.includes('/login')) {
          this.auth.logoutWithExpiredSession();
        }

        this.logger.error(err);
      }
    }));
  }
}
